import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MarkdownToHTML } from './markdown-to-html.util';

@Pipe({
    name: 'markdown',
})

export class MarkdownPipe implements PipeTransform {

    constructor(
        private sanitizer: DomSanitizer,
    ) {
    }

    /**
     * Tansforms raw markdown text into HTML
     * @param value The raw markdown text to be injected
     * @param allowImageClick False by default. If the markdown will be used out on the floor, keep this at false.
     * @returns HTML injection for markdown text
     */
    transform(value: string, allowImageClick = false): SafeHtml {
        let test = MarkdownToHTML(value, allowImageClick)
        return test
        // return this.sanitizer.bypassSecurityTrustHtml(test);
    }
}